import FileExport from './component'

export default FileExport
